import React from "react"
import './Tooltip.scss'
const Tooltip = ({ label }) => {
    return (
        <label className="tooltiptext">{label}</label>
    )
}

export default Tooltip;